import { ControlledCustomSelect } from '@sravni/cosago-react-library/lib/components';
import { useFormContext } from '@sravni/cosago-react-library/lib/hooks';
import type { IFieldFactoryProps } from '@sravni/cosago-react-library/lib/types';
import { Space } from '@sravni/react-design-system';
import type { ComponentProps } from 'react';
import { useMemo, useCallback } from 'react';

import { Switch } from 'shared/ui/Switch';

import { type TAdditionalDataFormFields, useDictionaries } from 'entities/creditForm';

import { AdditionalInfoTexts } from 'features/UpdateAdditionalInfo';

export const CarAvailability: FC<IFieldFactoryProps> = (props) => {
  const { carAvailabilityTypes } = useDictionaries(['carAvailabilityTypes']);
  const { watch, setValue } = useFormContext<TAdditionalDataFormFields>();
  const { type, ...other } = props;
  const isOpen = watch('carAvailabilityToggleEnabled');
  const nothingOption = useMemo(() => carAvailabilityTypes.find((item) => item.value === 'No'), [carAvailabilityTypes]);

  const handleToggle: ComponentProps<typeof Switch>['onChange'] = useCallback(
    (event) => {
      const value = event.currentTarget.checked;
      setValue('carAvailabilityToggleEnabled', value);
      if (!value) {
        setValue('carAvailability', nothingOption || null, { shouldValidate: true });
      }
    },
    [setValue, nothingOption],
  );

  const options = useMemo(() => carAvailabilityTypes.filter((item) => item.value !== 'No'), [carAvailabilityTypes]);

  return (
    <Space
      direction="vertical"
      size={16}
    >
      <Switch
        checked={isOpen}
        onChange={handleToggle}
      >
        {AdditionalInfoTexts.carAvailabilityToggleEnabled}
      </Switch>
      {isOpen && (
        <ControlledCustomSelect
          {...other}
          name={type}
          options={options}
          withCrossIcon={false}
        />
      )}
    </Space>
  );
};
